import Vue from 'vue'

export default {
  setCurrentCampaignId: (state, value) => {
    state.currentCampaignId = value
  },
  setCampaigns: (state, value) => {
    state.campaigns = value
  },
  setTranslations: (state, value) => {
    state.campaigns = value
  },
  setTranslationValue: (state, data) => {
    Vue.set(state.translations, data.key, data.value)
  },
  setSelectedLanguage: (state, value) => {
    state.selectedLanguage = value
  },
  // addTranslation: (state, value) => {
  //   if (!this.translations[this.selectedLanguage]) {
  //     state.translations[]
  //   }
  // },
  setIsNew: (state, value) => {
    state.isNew = value
  },
  setIsTemplate: (state, value) => {
    state.isTemplate = value
  },
  setCampaign: (state, value) => {
    if (value && value.Zones.length) {
      value.Zones = value.Zones.slice(1, -1).split('|')
    }
    state.campaign = value
  },
  setRegistrants: (state, value) => {
    state.registrants = value
  },
  setInviting: (state, value) => {
    state.inviting = value
  },
  addCampaign: (state, value) => {
    const exists = state.campaigns.some(campaign => {
      return campaign.Id === value.Id
    })
    if (!exists) {
      state.campaigns.push(value)
    }
  },
  addRegistrant: (state, value) => {
    const exists = state.campaigns.some(registrant => {
      return registrant.Id === value.Id
    })
    if (!exists) {
      state.registrants.push(value)
    }
  },
  addCampaignPromoCode: (state, value) => {
    state.campaign.PromoCodes.push(value)
  },
  setCampaignInCampaignsArray: (state, payload) => {
    if (state.campaigns.length) {
      const existingWhitelist = state.campaigns.find(
        campaign => campaign.Id === payload.ID
      )
      Object.assign(existingWhitelist, payload)
    }
  },
  /**
   * Sets specified key value on campaign Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setCampaignValue: (state, data) => {
    Vue.set(state.campaign, data.key, data.value)
  },
  removeCampaignFromArray: (state, campaignId) => {
    const index = state.campaigns.findIndex(
      campaign => campaign.Id === campaignId
    )
    state.campaigns.splice(index, 1)
  }
}
